<template>
  <div class="table-responsive">
    <div v-if="reports.length > 0">
      <table class="table table-hover table-bordered" id="example">
        <thead>
          <tr>
            <th>Created At</th>

            <th>Title</th>
            <th>Reference</th>
            <th>Type</th>
            <th>Status</th>
            <th>Method</th>
            <th>Unit Amount</th>
            <th>
              Actions
            </th>
          </tr>
        </thead>
        <tbody>
          <tr v-for="(report, index) in reports" :key="index">
            <td>{{ report.created_at | date }}</td>
            <td>{{ report.title }}</td>
            <td>{{ report.reference }}</td>
            <td>{{ report.type }}</td>
            <td>{{ report.status }}</td>
            <td>{{ report.method }}</td>
            <td>{{ report.unit_amount }}</td>

            <td>
              <router-link
                :event="permissions.includes('view-transaction') ? 'click' : ''"
                class="button"
                :class="
                  permissions.includes('view-transaction')
                    ? ''
                    : 'disabled cursor-not-allowed'
                "
                :to="{ name: 'Payment', params: { slug: report.reference } }"
              >
                View Transaction
              </router-link>
            </td>
          </tr>
        </tbody>
      </table>
    </div>
  </div>
</template>

<script>
import ApiService from "@/services/api.service";
import "datatables.net-dt/js/dataTables.dataTables";
import "datatables.net-dt/css/jquery.dataTables.min.css";
import "datatables.net-buttons/js/dataTables.buttons";
import "datatables.net-buttons/js/buttons.colVis";
import "datatables.net-buttons/js/buttons.flash";
import "datatables.net-buttons/js/buttons.html5";
import "datatables.net-buttons/js/buttons.print";
import Swal from "sweetalert2";
export default {
  props: {
    start_date: {
      type: String,
      default: "",
      required: false
    },
    stop_date: {
      type: String,
      default: "",
      required: false
    },
    search: {
      type: String,
      default: "",
      required: false
    },
    plan: {
      type: String,
      default: "",
      required: false
    }
  },
  data() {
    return {
      reports: []
    };
  },
  computed: {
    permissions() {
      let permissions = this.$store.getters.userObj.admin.permissions;
      return permissions;
    }
  },
  methods: {
    async getReports() {
      console.log("here");
      console.log(this.start_date, this.stop_date, this.search, this.plan);
      this.reports = [];
      try {
        const response = await ApiService.get(
          `backend/transactions/all-transactions?start_date=${this.start_date}&stop_date=${this.stop_date}&search=${this.search}&plan=${this.plan}`
        );
        console.log("rsponse", response, response.data.data.length);

        // this.$store.commit("setReportsLoading", false);
        if (response.data.data.length > 0) {
          this.reports = response.data.data;
          setTimeout(function() {
            // eslint-disable-next-line no-undef
            $("#example").DataTable({
              pagingType: "numbers",
              pageLength: 100,
              retrieve: true,
              responsive: true,
              processing: true,
              dom: "Bfrtip",
              buttons: ["copy", "csv", "print"]
            });
          }, 1000);
        } else {
          this.plan = "";
          this.search = "";
          Swal.fire({
            title: "Info!",
            icon: "info",
            text: "No Result Founds...",
            timer: 3000,
            timerProgressBar: true
          });
          this.getReports();
        }
      } catch (error) {
        // this.$store.commit("setReportsLoading", false);
        this.reports = [];
        let _error = error.response;
        Swal.fire({
          title: "Error!",
          icon: "error",
          text: _error.data
            ? _error.data.response_description
            : "Server Error, Try Again"
        });
      }
    }
  },
  mounted() {
    // eslint-disable-next-line no-undef
    console.log($("#example"));
    this.getReports();
  }
};
</script>

<style scoped>
#dot {
  width: 8px;
  height: 8px;
  display: inline-block;
  border-style: solid;
  border-width: 4px;
  border-radius: 100%;
  /* color: red; */
}
</style>
